import { useState } from "react";
import { Icon } from "assets/Icon";
import SelectedValueModal from "./SelectedValueModal";
import FuncButtonStyled from "components/FuncButton/FuncButtonStyled";

export type SmartFieldType = "project-experience" | "key-personnel";

type SelectedModalButtonProps = {
	companyId?: number;
	questionId?: number;
	selectedData?: Record<string, unknown>[];
	type: SmartFieldType;
};

export const SelectedModalButton = ({
	type,
	questionId,
	companyId,
	selectedData,
}: SelectedModalButtonProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleButtonClick = () => {
		setIsOpen(true);
	};

	return (
		<>
			<FuncButtonStyled
				type="button"
				onClick={handleButtonClick}
			>
				Selected {type === "project-experience" ? "Projects" : "Key Personnel"}
				<Icon
					icon="arrow-up-right"
					sx={undefined}
					size={16}
					width={16}
					height={16}
					strokeWidth={2}
					className=""
					color={undefined}
					isDanger={false}
				/>
			</FuncButtonStyled>
			<SelectedValueModal
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				type={type}
				questionId={questionId ?? 0}
				companyId={companyId ?? 0}
				selectedData={selectedData ?? []}
			/>
		</>
	);
};
